import { render, staticRenderFns } from "./HotsitesTable.vue?vue&type=template&id=13cc0b76&scoped=true&"
import script from "./HotsitesTable.vue?vue&type=script&lang=ts&"
export * from "./HotsitesTable.vue?vue&type=script&lang=ts&"
import style0 from "./HotsitesTable.vue?vue&type=style&index=0&id=13cc0b76&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc0b76",
  null
  
)

export default component.exports